import React from 'react';
import { Box, Typography } from '@mui/material';
import { InfoCircleIcon } from './icons';

export default function RecommendationBanner({ os }) {
    const label = os === 'windows' ? 'Windows' : 'macOS';
    return (
        <Box
            sx={{
                mb: 3,
                backgroundColor: '#EFF6FF',
                border: '1.5px solid #BFDBFE',
                borderRadius: '12px',
                padding: '13px 18px',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <InfoCircleIcon />
            <Typography variant="body2" color="#1E40AF">
                Looks like you&apos;re on <strong>{label}</strong> — the recommended download is highlighted below.
            </Typography>
        </Box>
    );
}
